import axios from 'axios'
import $ from 'jquery'
import keys from 'lodash/keys'
import Store from 'store'

import { get_email_from_queries } from '@/common/tracking-utils'
import { get_queries_from_url } from '@/utils'
import StorageKeys from '../common/storage-keys'
import TrackVideoWatchMixin from '../components/video/track-video-watch-mixin'

export default {
  mixins: [TrackVideoWatchMixin],
  data() {
    return {
      trackData: {
        email: null,
        contact: null,
        campaign: null,
        workflow: null,
        sharer: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_content: null,
        utm_term: null,
      },
      queries: get_queries_from_url(),
    }
  },

  computed: {
    isSelf() {
      return false
    },
    shouldTrack() {
      return !this.isSelf && this.queries.track !== '0'
    },
    trackParams() {
      if (this.shouldTrack) {
        return this.trackData
      }

      return {}
    },
  },

  methods: {
    initTrackData(canonical = null) {
      if (this.shouldTrack) {
        keys(this.trackData).forEach((field) => {
          this.trackData[field] = this.queries[field] || null
        })

        if (canonical) {
          this.trackData.email = get_email_from_queries(canonical, this.queries)
        }

        this.checkLocalTrackData()
      }
    },
    checkLocalTrackData() {
      // if the trackData is empty, then use the local storage trackData
      const isEmptyTrackData = keys(this.trackData).every(field => !this.trackData[field])

      if (isEmptyTrackData) {
        const trackData = Store.get(StorageKeys.VIDEO_SHOW.TRACK_DATA)

        if (trackData) {
          this.trackData = trackData
        }

        return
      }

      Store.set(StorageKeys.VIDEO_SHOW.TRACK_DATA, this.trackData)
    },
    initTrack() {
      if (this.shouldTrack) {
        this.trackView(!!this.queries.from_email)

        $(window).on('beforeunload', () => {
          this.smartTrackVideoWatch(this.currentVideo, this.player, this.trackParams, true)
        })
      }
    },
    track(data) {
      if (this.shouldTrack) {
        axios.post(this.router('api.video.track', { video: this.currentVideo.id, type: data.type }), {
          ...this.trackParams,
          ...data,
        }, {
          ignoreGlobalCatch: true,
        })
      }
    },
    trackView(fromEmail) {
      if (fromEmail) {
        this.track({
          type: this.constants.App_Models_Track.ACTION_CLICK_EMAIL,
        })
      }

      this.track({
        type: this.constants.App_Models_Track.ACTION_VIEW,
      })
    },
    trackWatch() {
      if (this.shouldTrack) {
        this.smartTrackVideoWatch(this.currentVideo, this.player, this.trackParams)
      }
    },
    trackCallToAction(action) {
      this.track({
        type: this.constants.App_Models_Track.ACTION_CLICK_CTA,
        data: {
          cta_id: action.id,
          cta_name: action.name,
          cta_type: action.type,
        },
      })
    },
    trackEmoji(emoji) {
      this.track({
        type: this.constants.App_Models_Track.ACTION_EMOJI,
        data: {
          emoji,
        },
      })
    },
    trackFormSubmission(submission) {
      if (submission.contact) {
        this.track({
          type: this.constants.App_Models_Track.ACTION_FORM,
          email: submission.contact.email,
          contact: submission.contact.hash_id,
        })
      }
    },
  },
}
